import { useIsMounted } from "@react-hookz/web";
import { useCallback, useState } from "react";

export interface CopyToClipboardState {
  value?: string;
  error?: Error;
}

export const useCopyToClipboard = (): [
  CopyToClipboardState,
  (value: string) => void,
] => {
  const isMounted = useIsMounted();
  const [state, setState] = useState<CopyToClipboardState>({
    value: undefined,
    error: undefined,
  });
  const copyToClipboard = useCallback((value: string) => {
    if (!isMounted()) {
      return;
    }
    try {
      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(value).then(
          () =>
            setState({
              value: value,
              error: undefined,
            }),
          (error) =>
            setState({
              value: value,
              // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
              error: error,
            }),
        );
      } else {
        setState({
          value: value,
          error: new Error("Clipboard API not available"),
        });
      }
    } catch (error) {
      setState({
        value: value,
        error: error as Error,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return [state, copyToClipboard];
};
